"use client";

import { NumericProgress } from "@/components/ui/progress/NumericProgress";
import { ProgressBar } from "@/components/ui/progress/ProgressBar";
import { ProgressStatus } from "@/components/ui/progress/ProgressStatus";
import { ConversionConstructedNoDates } from "@/types/types";

export function NotDoneConversion({
  conversion,
}: {
  conversion: ConversionConstructedNoDates;
}) {
  const percentageDone = conversion.percentageDone;

  // We want to show "Starting" if the conversion is more than 10% done
  const hasProgress = conversion.percentageDone > 10;
  return (
    <div className="flex h-full flex-col justify-between">
      <div className="flex flex-row items-center">
        <ProgressBar progress={percentageDone} />
        <NumericProgress progress={percentageDone} />
      </div>
      <div className="mt-4">
        <ProgressStatus processType={hasProgress ? "Converting" : "Starting"} />
      </div>
    </div>
  );
}
